import { apiSlice } from "./apiSlice";

export const homeApiSlice = apiSlice.injectEndpoints({
  tagTypes: ["Banner", "PopupBanner", "AppDownloadOverlayConfig", "Lookup", "HomePage", "ReferralPage", "GameArticles"],
  endpoints: (builder) => ({
    getBanner: builder.query({
      query: () => "/home/api/v1/banner",
      providesTags: ["Banner"],
    }),
    getPopupBanner: builder.query({
      query: () => "/home/api/v1/popupBanner",
      providesTags: ["PopupBanner"],
    }),
    getAppDownloadOverlayConfig: builder.query({
      query: () => "/home/api/v1/appDownloadOverlayConfig",
      providesTags: ["AppDownloadOverlayConfig"],
    }),
    getLookup: builder.query({
      query: () => "/home/api/v1/lookup",
      providesTags: ["Lookup"],
    }),
    getHomePage: builder.query({
      query: () => "/home/api/v1/homePage",
      providesTags: ["HomePage"],
    }),
    getReferralPage: builder.query({
      query: () => "/home/api/v1/referralSettings",
      providesTags: ["ReferralPage"],
    }),
    getGameArticles: builder.query({
      query: () => "/home/api/v1/gameArticles",
      providesTags: ["GameArticles"],
    }),
  }),
});

export const { useGetBannerQuery, useGetPopupBannerQuery, useGetAppDownloadOverlayConfigQuery, useGetLookupQuery, useGetHomePageQuery, useGetReferralPageQuery, useGetGameArticlesQuery } =
  homeApiSlice;
